import React from "react";

const FormWarning = (props) => {
  const warningStyles = {
    warning: {
      color: "red",
      display: "flex",
      justifyContent: "end",
      marginTop: "6px",
      lineHeight: "14px",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontSize: "10px",
    },
    condWarning: {
      color: "red",
      display: "flex",
      justifyContent: "end",
      marginTop: "9px",
      lineHeight: "14px",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      fontSize: "10px",
    },
  };

  return (
    <div>
      {props.isValid !== "" && props.isError === "Error" ? (
        props.isValid === "regionid" ||
        props.isValid === "phoneType1" ||
        props.isValid === "advSrc" ||
        props.isValid === "ats_township" ||
        props.isValid === "ats_quarter" ||
        props.isValid === "ats_section" ||
        props.isValid === "ats_range" ||
        props.isValid === "ats_meridian" ? (
          <span style={warningStyles.condWarning}> {props.errorMessage} </span>
        ) : (
          <span style={warningStyles.warning}> {props.errorMessage} </span>
        )
      ) : (
        ""
      )}
    </div>
  );
};

export default FormWarning;
